import React from 'react';

import { Container, Content, Body, PhoneNumberSmall } from './ContactModal.styled';
import { Modal } from 'components/v2/Modal/Modal';
import { usePatient } from 'hooks/usePatient/usePatient';
import { getLabInfo } from 'kb-shared/utilities/kindbody_contacts';

interface Props {
  visible: boolean;
  onDismiss: Function;
}

const ContactModal = ({ visible, onDismiss }: Props) => {
  const { patient } = usePatient();
  const marketId = patient?.lab?.id;
  const lab = getLabInfo(marketId);

  return (
    <Modal open={visible} onCancel={() => onDismiss()} title="Contact us">
      <Container>
        <Content>
          <Body>
            If this is a medical emergency, please call{' '}
            <PhoneNumberSmall href="tel:911">911</PhoneNumberSmall> <br />
            <br />
            If you need to speak to medical provider urgently please <br />
            call <PhoneNumberSmall href={`tel:${lab.number}`}>{lab.numberLabel}.</PhoneNumberSmall>
            <br />
          </Body>
        </Content>
      </Container>
    </Modal>
  );
};

export default ContactModal;
